import React, { createContext } from 'react';
import PropTypes from 'prop-types';

export const BundleMiniContext = createContext();

export const BundleMiniContextProvider = ({ itemId, children }) => {
  return (
    <BundleMiniContext.Provider value={{ itemId }}>
      {children}
    </BundleMiniContext.Provider>
  );
};

BundleMiniContextProvider.propTypes = {
  itemId: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired
};